jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     //console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

   ///////////////////// product-metafield-options.liquid ////////////////////
    $(document).on('change', '.pro-options', function(e) {
          var op1 = $(".pro-options.op1").val();
          var op2 = $(".pro-options.op2").val();
        
          var op3 = $(".pro-options.op3").val();
          var op4 = $(".pro-options.op4").val();
          var op5 = $(".pro-options.op5").val();
        
        
          var handle1 = ($(".pro-options.op1 option:selected").attr("handle"))? $(".pro-options.op1 option:selected").attr("handle") :'';
          var handle2 = ($(".pro-options.op2 option:selected").attr("handle"))? "-"+$(".pro-options.op2 option:selected").attr("handle") :'';
        
          var handle3 = ($(".pro-options.op3 option:selected").attr("handle"))? "-"+$(".pro-options.op3 option:selected").attr("handle") :'';
          var handle4 = ($(".pro-options.op4 option:selected").attr("handle"))? "-"+$(".pro-options.op4 option:selected").attr("handle") :'';
          var handle5 = ($(".pro-options.op5 option:selected").attr("handle"))? "-"+$(".pro-options.op5 option:selected").attr("handle") :'';
        
          var shopURL = $(".dropdown-area").attr("shop-url");//"{{ shop.url }}";
        
          var title = op1+" "+op2+" "+op3+" "+op4+" "+op5;
          var handle = handle1+handle2+handle3+handle4+handle5//$(".pro-options.op1 option:selected").attr("handle")+"-"+$(".pro-options.op2 option:selected").attr("handle")+"-"+$(".pro-options.op3 option:selected").attr("handle")+"-"+$(".pro-options.op4 option:selected").attr("handle")+"-"+$(".pro-options.op5 option:selected").attr("handle");
          var redirectOn = shopURL+"/products/"+handle;

          /*if(handle1.indexOf("v2-iphone") == -1){
            redirectOn = redirectOn.replace("side-", "");
            redirectOn = redirectOn.replace("center-", "");
            //console.log("v2-iphone not found");
          } else {
            //console.log("v2-iphone found");
            if(handle2.indexOf("premium-case") == -1){
              if(handle2.indexOf("side-") == -1 || handle2.indexOf("center-") == -1){
                      
              }
            }
          }*/ 
        
          window.location.href = redirectOn;
  });
  ///////////////////////////////////////////////////////

  ///////////////////// product-gift-section.liquid ////////////////////
  $('.gift-product-inner').on('click', function(){
     if($("#gift-product").is(":checked")) {
       $("#gift-product").prop('checked', false);
        $(".gift-note-text").hide();
        $(".gift-note-text").removeAttr("name");
        $(".gift-note-text").val("");
     } else {
        $("#gift-product").prop("checked", true);
        $(".gift-note-text").show();
     }
  });

  function toggleCheckbox(checkboxSelector) {
    $(checkboxSelector).prop("checked", !$(checkboxSelector).prop("checked"));
  }
  $('#gift-product').on('click', () => {
    toggleCheckbox('#gift-product');
  });
    
  $('.gift-note-text').keyup(function() {
    var characterCount = $(this).val().length;
    if(characterCount > 0){
      var gift_item_id = $(".gift-product").data('item-id');
      $(this).attr("name","items["+gift_item_id+"][properties[Gift Note]]");
    } else {
      $(this).removeAttr("name");
    }
  });
  ///////////////////////////////////////////////////////  

  ////////////// extra product add section  //////////////////

  function toggleExtraProductSlider(element) {
      var elementThis = $(element);
      var checkboxClick = elementThis.find('.extra-product');
      var productSlider = elementThis.siblings('.extra-strap-product-slider');
      
      if (checkboxClick.is(':checked')) {
          productSlider.show();
          initializeFlickity(productSlider);
      } else {
          productSlider.hide();
      }
  }


  $('.extra-product-inner').each(function () {
     toggleExtraProductSlider(this);
  });

    // Handle clicks on the .extra-product-inner container (excluding the checkbox)
    $('.extra-product-inner').on('click', function (e) {
        if ($(e.target).is('.extra-product')) return;
    
        var elementThis = $(this);
        var checkboxClick = elementThis.find('.extra-product');
        var productSlider = elementThis.siblings('.extra-strap-product-slider');
    
        var isChecked = !checkboxClick.is(':checked');
        checkboxClick.prop('checked', isChecked);
    
        if (isChecked) {
            productSlider.show();
            initializeFlickity(productSlider);
        } else {
            productSlider.hide();
        }
        $(this).closest(".extra-strap-product-section").find('.extra-strap-add-cart').prop('checked', false);
    });

    // Handle direct clicks on the checkbox
    $(document).on('click', '.extra-product', function () {
        var elementThis = $(this);
        var productSlider = elementThis.closest('.extra-product-inner').siblings('.extra-strap-product-slider');
        var isChecked = elementThis.is(':checked');

        $(this).closest(".extra-strap-product-section").find('.extra-strap-add-cart').prop('checked', false);
    
        if (isChecked) {
            productSlider.show();
            initializeFlickity(productSlider);
        } else {
            productSlider.hide();
        }
    });

    function initializeFlickity(productSlider) {
        if (!productSlider.hasClass('flickityt4s-enabled')) {
            var options = JSON.parse(productSlider.attr('data-flickityt4s-js'));
            productSlider.flickityt4s(options);
        } else {
            productSlider.flickityt4s('resize');
        }
    }


  ///////////////////// product-upsell-section.liquid ////////////////////
  //update the add-cart-button color if pre-order
  //  function updatePreorderbutton(currentVariant){
  //   var isPreOrder = currentVariant.inventory_management == 'shopify' && currentVariant.inventory_quantity <= 0 && currentVariant.available;
  //    if(isPreOrder){
  //      if($(".t4s-product-form__buttons").length > 0 && !$('.t4s-product-form__submit').hasClass('t4s-btn-preorder')) {
  //        $(".t4s-product-form__submit").addClass("t4s-btn-preorder");
  //      }
  //     if($(".t4s-sticky-atc__btns").length > 0 && !$('.t4s-sticky-atc__atc').hasClass('t4s-btn-preorder')) {
  //        $(".t4s-sticky-atc__atc").addClass("t4s-btn-preorder");
  //      }
  //    }else {
  //      if($(".t4s-product-form__buttons").length > 0 && $('.t4s-product-form__submit').hasClass('t4s-btn-preorder')) {
  //        $(".t4s-product-form__submit").removeClass("t4s-btn-preorder");
  //      }
  //      if($(".t4s-sticky-atc__btns").length > 0 && $('.t4s-sticky-atc__atc').hasClass('t4s-btn-preorder')) {
  //        $(".t4s-sticky-atc__atc").removeClass("t4s-btn-preorder");
  //      }
  //    }

  //   if( !currentVariant.available){
  //     if($(".t4s-pr__notify-stock").length > 0){      
  //      $(".t4s-pr__notify-stock").attr('style', 'display: inline-block !important');
  //     } 
  //   } else {
  //     if($(".t4s-pr__notify-stock").length > 0){      
  //      $(".t4s-pr__notify-stock").attr('style', 'display: none');
  //     }
  //   }
  //  }

  // function updatePreorderbutton(currentVariant) {
  //   // Get metafield value for this variant (from global variable created earlier)
  //   var metafieldData = window.variantMetafields && window.variantMetafields[currentVariant.id];
  //   var preorderSwitch = metafieldData ? metafieldData.pre_order_to_add_to_cart_switch : null;

  //   // Default logic to determine if this should show preorder
  //   var isPreOrder = currentVariant.inventory_management == 'shopify' &&
  //                   currentVariant.inventory_quantity <= 0 &&
  //                   currentVariant.available;

  //   // ----- Select elements -----
  //   var productBtn = $(".t4s-product-form__submit");
  //   var stickyBtn = $(".t4s-sticky-atc__atc");
  //   var buttonText = $(".t4s-product-form__submit .t4s-btn-atc_text");
  //   var stickyBtnText = $(".t4s-sticky-atc__atc .t4s-btn-atc_text");
  //   var preorderBadge = $("[data-badge-preorder]");
  //   var estimatedTime = $("[data-incoming-available]");

  //   // ----- Add/Remove preorder classes and update text -----
  //   if (isPreOrder && preorderSwitch === true) {
  //     if ($(".t4s-product-form__buttons").length > 0 && productBtn.hasClass("t4s-btn-preorder")) {
  //       productBtn.removeClass("t4s-btn-preorder");
  //     }
  //     if ($(".t4s-sticky-atc__btns").length > 0 && stickyBtn.hasClass("t4s-btn-preorder")) {
  //       stickyBtn.removeClass("t4s-btn-preorder");
  //       stickyBtn.text("ADD TO CART");
  //     }
  //     // Change button text to "Add to cart"
  //     buttonText.text("ADD TO CART");
  //     preorderBadge.attr("hidden", "hidden");
  //     estimatedTime.attr("style", "display: none");
  //   } else if(isPreOrder) {
  //     if ($(".t4s-product-form__buttons").length > 0 && !productBtn.hasClass("t4s-btn-preorder")) {
  //       productBtn.addClass("t4s-btn-preorder");
  //       estimatedTime.attr("style", "display: block");
  //     }
  //     if ($(".t4s-sticky-atc__btns").length > 0 && !stickyBtn.hasClass("t4s-btn-preorder")) {
  //       stickyBtn.addClass("t4s-btn-preorder");
  //       estimatedTime.attr("style", "display: block");
  //     }
  //   } 

  //   // ----- Handle "notify when back in stock" visibility -----
  //   if (!currentVariant.available) {
  //     if ($(".t4s-pr__notify-stock").length > 0) {
  //       $(".t4s-pr__notify-stock").attr("style", "display: inline-block !important");
  //     }
  //   } else {
  //     if ($(".t4s-pr__notify-stock").length > 0) {
  //       $(".t4s-pr__notify-stock").attr("style", "display: none");
  //     }
  //   }
  // }

  function updatePreorderbutton(currentVariant) {
    var metafieldData = window.variantMetafields && window.variantMetafields[currentVariant.id];
    var preorderSwitch = metafieldData ? metafieldData.pre_order_to_add_to_cart_switch : null;

    var isPreOrder = currentVariant.inventory_management == 'shopify' &&
                    (currentVariant.inventory_quantity <= 0 || currentVariant.inventory_quantity == undefined) 
                    && currentVariant.available;

    // ----- Select elements (cache properly) -----
    var productBtn = $(".t4s-product-form__submit");
    var stickyBtn = $(".t4s-sticky-atc__atc");

    var productBtnText = $(".t4s-product-form__submit .t4s-btn-atc_text");
    var stickyBtnText = $(".t4s-sticky-atc__atc .t4s-btn-atc_text");

    var preorderBadge = $("[data-badge-preorder]");
    var estimatedTime = $("[data-incoming-available]");
    var notifyStock = $(".t4s-pr__notify-stock");

    var delivaryTime = $(".t4s-pr_delivery");

    console.log(preorderSwitch, "preorderSwitch---", isPreOrder, currentVariant.inventory_management, currentVariant.inventory_quantity, currentVariant.available);
    console.log(hideDelivary, "hideDelivary");
    

    // ----- Preorder OFF (force Add to Cart) -----
    if (isPreOrder && preorderSwitch === true) {

      productBtn.removeClass("t4s-btn-preorder");
      stickyBtn.removeClass("t4s-btn-preorder");

      productBtnText.text("ADD TO CART");
      stickyBtnText.text("ADD TO CART");

      preorderBadge.attr("hidden", "hidden");
      estimatedTime.hide();
      delivaryTime.show();
    } 

    else if (isPreOrder && preorderSwitch === false) {
      if(hideDelivary) {
        delivaryTime.hide();
      } else {
        delivaryTime.show();
      }
    }
    // ----- Preorder ON -----
    else if (isPreOrder) {

      productBtn.addClass("t4s-btn-preorder");
      stickyBtn.addClass("t4s-btn-preorder");

      estimatedTime.show();
      if(hideDelivary) {
        delivaryTime.hide();
      } else {
        delivaryTime.show();
      }
    } 
    else if (!isPreOrder) {

      productBtn.removeClass("t4s-btn-preorder");
      stickyBtn.removeClass("t4s-btn-preorder");

      // productBtnText.text("ADD TO CART");
      // stickyBtnText.text("ADD TO CART");

      estimatedTime.hide();
    } 

    // ----- Normal product (in stock) -----
    else {

      productBtn.removeClass("t4s-btn-preorder");
      stickyBtn.removeClass("t4s-btn-preorder");

      productBtnText.text("ADD TO CART");
      stickyBtnText.text("ADD TO CART");

      estimatedTime.hide();
      delivaryTime.show();
    }

    // ----- Notify when out of stock -----
    if (!currentVariant.available) {
      notifyStock.show();
    } else {
      notifyStock.hide();
    }
  }

  // setTimeout(function () {
  //   if (window.currentVariant) {
  //     console.log("Running updatePreorderbutton on load:", window.currentVariant.id, window.currentVariant);
  //     // updatePreorderbutton(window.currentVariant);
  //   } else {
  //     console.warn("No currentVariant found on page load.");
  //   }
  // }, 2000); // delay 300ms (adjust if needed)

    // Update variant id for product grid
  function UpdateVariantIDforPrGrid(href,product,vid) {
        if (href.indexOf("?variant=") > -1) {
          product.find('a').attr('href',href.split('?variant=')[0]+'?variant='+vid);
        } else if (href.indexOf("?") > -1) {
          product.find('a').attr('href',href.split('&variant=')[0]+'&variant='+vid);
        } else {
          product.find('a').attr('href',href+'?variant='+vid);
        }
        product.attr('var-id',vid);
        if(product.find('.upsell-add-cart').length > 0){
          product.find('.upsell-add-cart').attr('data-product-id',vid);
      }
    };

    function swatches_js( $this ) {
      var pr_curent = T4Sconfigs.pr_curent,
        imagebg = $this.data('img'),
        id = $this.data('imgid'),
        vid = $this.data('vid'),
        product = ($this.parents('.upsell-item').length > 0 ? $this.parents('.upsell-item') : ($this.parents('.cart-upsell-single').length > 0 ? $this.parents('.cart-upsell-single') : '')),
        image = (product.find('.upsell-img-wrapper img').length > 0 ?  product.find('.upsell-img-wrapper img') : (product.find('.img img').length > 0 ?  product.find('.img img') : '')),
        id_img = image.attr('data-imgid'),
        href = (product.find('.upsell-img-wrapper>a').length > 0 ? product.find('.upsell-img-wrapper>a').attr('href') : (product.find('.info>a').length > 0 ? product.find('.info>a').attr('href'): ''));

        if( id  == id_img ) return;

        imagebg = imagebg.replace('.jpg', '_100x100.jpg').replace('&width=1', '').trim();
        imagebg = imagebg.replace('.png', '_100x100.png').replace('&width=1', '').trim();

      var daradImage = $this.data('img').replace('.jpg', '_200x200.jpg').replace('&width=1', '').trim();
      var daradImage = $this.data('img').replace('.png', '_200x200.png').replace('&width=1', '').trim();
      image.attr('data-id', id).attr('src', imagebg);
      product.attr('var-image', daradImage);
      if ( pr_curent == '1') return;
      UpdateVariantIDforPrGrid(href,product,vid);
    };

    $( document ).on( "variant:changed", function( evt ) {
    updatePreorderbutton(evt.currentVariant);
    if( $('.is-t4s-style__color div.is--selected').length > 1){
        var color_selection = $('.is-t4s-style__color:nth-child(2) div.is--selected').attr("data-value").toLowerCase();
    } else {
      var color_selection = $('.is-t4s-style__color div.is--selected').attr("data-value").toLowerCase();
    }
    //var color_selection = $('.is-t4s-style__color div.is--selected').attr("data-value").toLowerCase();
    var select = $(".upsell-product-section .t4s-product-colors .bg_color_"+color_selection).parent('.t4s-pr-color__item');
    var cartDrawerSelect = $(".drawer-upsell-products .custom-t4s-product-colors .bg_color_"+color_selection).parent('.t4s-pr-color__item');
      select.each(function(){
          swatches_js($(this));
      });

      cartDrawerSelect.each(function(){
        swatches_js($(this));
      });
    });

    $(document).on('click', '.t4s-swatch__list > .t4s-swatch__item:not(.is--soldout)', function() {
    if( $('.is-t4s-style__color div.is--selected').length > 1){
      var color_selection = $('.is-t4s-style__color:nth-child(2) div.is--selected').attr("data-value").toLowerCase();
    } else {
      var color_selection = $('.is-t4s-style__color div.is--selected').attr("data-value").toLowerCase();
    }
    //var color_selection = $('.is-t4s-style__color div.is--selected').attr("data-value").toLowerCase();
      color_selection = color_selection.replace(/ /g, '-');
    var select = $(".upsell-product-section .t4s-product-colors .bg_color_"+color_selection).parent('.t4s-pr-color__item');
    var cartDrawerSelect = $(".drawer-upsell-products .custom-t4s-product-colors .bg_color_"+color_selection).parent('.t4s-pr-color__item');
      select.each(function(){
          swatches_js($(this));
      });

      cartDrawerSelect.each(function(){
        swatches_js($(this));
      });

    });
    
    function addFetchFrom(form_id, upsellProductId, _this) {
      var body = $('body'),
      $document = $(document),
      page_type = T4Srequest.page_type,
      cartTypeIsDisable = (T4Sconfigs.cartType == 'disable'),
      strCartDataMini = cartTypeIsDisable ? 'cart_data' : 'cart_data,mini_cart',
      sections_nt = (page_type != 'cart') ? strCartDataMini : `cart_data,${window.cartT4SectionID}`, 
      sections_ntArray  = sections_nt?.split(',');
      
      var formData = {
        'items': [{id: upsellProductId, quantity: "1"}],
        'sections': sections_ntArray,
        'sections_url': window.location.pathname
        };

      var  cartAddUrl = T4Sroutes.cart_add_url + '.js';
    
      fetch(cartAddUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(function(response) { return response.json(); })
            .then(function(response) {
                if (response.status && response.status !== 200) {
                  handleErrorMessage(response.description);
                  $document.trigger('cart:updated');
                  return;
                }
                _this.removeClass('loading');
                  $document.trigger('add:cart:success').trigger('add:cart:upsell');
                    T4SThemeSP.isATCSuccess = true;
                    T4SThemeSP.Cart.renderContents(response.sections);
              })
              .catch(function(error) {
                _this.removeClass('loading');
                $document.trigger('cart:updated');
                console.log(error);
            });
    };
    $(document).on("click", ".upsell-add-cart", function(){
    //$('.upsell-add-cart').on('click', function(){
            var _this = $(this),
            frmId = _this.closest('form'),
            upsellId =  $(this).attr('data-product-id');
      
            _this.addClass('loading');
            if(typeof upsellId != undefined && upsellId != ''){
              setTimeout(() => {
                addFetchFrom(frmId, upsellId, _this);
              }, 1000)
            }
            
    });
    /*$(document).on("click", ".extra-strap-add-cart", function(){
            var _this = $(this),
            frmId = _this.closest('form'),
            upsellId =  $(this).attr('data-product-id');
      
            _this.addClass('loading');
            if(typeof upsellId != undefined && upsellId != ''){
              setTimeout(() => {
                addFetchFrom(frmId, upsellId, _this);
              }, 1000)
            }
            
    });*/


      $('.extra-strap-add-cart-select').on('click', function (event) {
          if ($(event.target).hasClass('extra-strap-add-cart')) {
              return;
          }
          const $checkbox = $(this).find('.extra-strap-add-cart');
          if ($checkbox.length ) {
              $checkbox.prop('checked', !$checkbox.prop('checked'));
          }
      });

      $('.extra-strap-add-cart').on('click', function (event) {
          event.stopPropagation();
      });

    //Custom-upsell-section add into sidebar cart
    setTimeout(function() {
      
      if($('.upsell-product-section').length != 0 && $('.cart-drawer-upsell').length == 0 && $('.mini-cart-upsell').length != 0){
          var upsell_html = "<div class='cart-drawer-upsell carousel'><span class='title'>"+$('.mini-cart-upsell').data('title')+"</span><div class='drawer-upsell-products'>";
          if($('.extra-strap-product-section').length != 0){
            $('.extra-strap-product-section .extra-strap-item').each(function(){
                var price_html = (JSON.parse($(this).attr("var-issale")) ?  "<span class='price money'>"+$(this).attr("var-price")+"</span><span class='compareatprice money'>"+$(this).attr("var-compare-at-price")+"</span>" : "<span class='price money'>"+$(this).attr("var-price")+"</span>");
                upsell_html += "<div class='extra-strap-upsell-single'><div class='img'><a href='/products/"+$(this).attr("var-handle")+"?variant="+$(this).attr("var-id")+"'><img src='"+$(this).attr("var-image")+"' alt='"+$(this).find("img").attr('alt')+"' data-id='"+$(this).find("img").attr('data-id')+"'></a></div><div class='info'><span class='title'>"+$(this).find(".product-name").text()+"</span>"+price_html+"<div class='button add-to-cart upsell-add-cart' data-product-id='"+$(this).attr("var-id")+"'><span class='add'>+ ADD</span></div></div></div>";
            });
          }      
          $('.upsell-product-section .upsell-item').each(function(){
            var price_html = (JSON.parse($(this).attr("var-issale")) ?  "<span class='price money'>"+$(this).attr("var-price")+"</span><span class='compareatprice money'>"+$(this).attr("var-compare-at-price")+"</span>" : "<span class='price money'>"+$(this).attr("var-price")+"</span>");
            upsell_html += "<div class='cart-upsell-single'><div class='img'><a href='/products/"+$(this).attr("var-handle")+"?variant="+$(this).attr("var-id")+"'><img src='"+$(this).attr("var-image")+"' alt='"+$(this).find("img").attr('alt')+"' data-id='"+$(this).find("img").attr('data-id')+"'></a></div><div class='info'><span class='title'>"+$(this).find(".product-name").text()+"</span>"+price_html+"<div class='button add-to-cart upsell-add-cart' data-product-id='"+$(this).attr("var-id")+"'><span class='add'>+ ADD</span></div></div></div>";
          });
          upsell_html += "</div></div>";

        $("#t4s-mini_cart .t4s-drawer__main .mini-cart-upsell").append(upsell_html);
        $('#t4s-mini_cart .t4s-drawer__main .mini-cart-upsell .drawer-upsell-products').css('display', 'flex');
        $('.upsell-product-section .upsell-item').each(function(index){
            var swatch_html =  (JSON.parse($(this).attr("data-colorCount")) > 0 ? $(this).find('.custom-t4s-product-colors') : '');
            $(".drawer-upsell-products .cart-upsell-single:nth-child(" + (index+1) + ")").append(swatch_html);
        });

      }
    }, 1000);
    
    ////////////////////product-tab-descriptions.liquid ///////////////////////
    $(".redirect-button").click(function(e){
      e.preventDefault();
      
      var id = $(this).attr("href");
      
      //$(".ul_tabs a[href='"+id+"']:visible").trigger("click");
      //$(id+":not(.t4s-active)").siblings(".t4s-tab__title:visible").trigger("click");
      if(!$(id).parent().hasClass('t4s-active')){
        $(id).trigger("click");
      }
      $('html, body').stop().animate({
          scrollTop: $(id).offset().top - 100
        }, 400);
    });
    ///////////////////////////////////////////////////////

    //////////////////// Bundle Box | Gift sets /////////////////////////
      /*var $carousel = $('.t4s-product__media-wrapper .t4s-flicky-slider');
      $carousel.on('ready.flickityt4s', function() {
          console.log('ready');
          if($("input[name='Gift set type']").length > 0){
            var selectedBundel =  $("input[name='Gift set type']:checked").val();
            console.log(selectedBundel);
          }
      });*/
    
    $(document).on("change", "input[name='Gift set type']", function() {
        var selectedBundel = this.value;
        var dataMid;
        if(!$("input[name='Gift set type']").is(':checked')) {
            $('*[data-t4s-gallery]').flickityt4s( 'select', 0);
        }
      
        $('.t4s-product__media-wrapper .flickityt4s-slider .t4s-product__media-item').each(function( index) {
              if($(this).find('img').attr('alt') == selectedBundel+' Image'){
                dataMid = $(this).data('media-id');
                $('*[data-t4s-gallery]').flickityt4s('select', index); 
              }
        });
    });

    $(document).on("change", ".gpo-swatches input[type='radio']", function() {
      var selectedColor = this.value;
      var optionName  = this.name;
      if(optionName == 'phone-strap-color' || optionName == 'phone-case-color'){
          var caseColor = $(".gpo-swatches input[name='phone-case-color']:checked").val();
          var strapColor = $(".gpo-swatches input[name='phone-strap-color']:checked").val();
          selectedColor = caseColor + ' '+strapColor;
      }
      $('.t4s-product__media-wrapper .flickityt4s-slider .t4s-product__media-item').each(function( index) {
            if($(this).find('img').attr('alt') == selectedColor+' Image'){
              $('*[data-t4s-gallery]').flickityt4s('select', index); 
            }
      });
    
    });
    ///////////////////////////////////////////////////////

    ////////////////// Cart page countdown timer //////////////
    function cartCountdown(){
      var cart_cd = $('[data-cart-countdown]');
      if(cart_cd.length == 0) return;
      
      //format = '%H:%M:%S',
      var mn = parseInt(cart_cd.attr('data-mn')),
          unit = cart_cd.data('unit'),
          nt_cartcd_mn = 'nt_cartcd'+unit+mn,
          val = (unit == 'min') ? mn * 60 * 1000 : mn * 60 * 60 * 1000,
          format = '%M min %S sec',
          selectedDate,
          totalHours = 0,
          after_atc_1 = ($('[data-after-cartcd-1]').length>0),
          params = {
            type: 'POST',
            url: '/cart/clear.js',
            data:  '',
            dataType: 'json',
            success: function(cart) {location.reload();},
            error: function(XMLHttpRequest, textStatus) {
              console.error(textStatus);
            }
          };

          if (localStorage.getItem(nt_cartcd_mn) !== null) {
                selectedDate = parseInt(localStorage.getItem(nt_cartcd_mn));
          } else {
              selectedDate = new Date().valueOf() + val;
              localStorage.setItem(nt_cartcd_mn, selectedDate);
          }
      
          cart_cd.countdown(selectedDate.toString()).on('update.countdown', function(event) {
              totalHours = event.offset.totalDays * 24 + event.offset.hours;
              if (totalHours > 24){
                format = totalHours+' hr %M min %S sec';
              } else if (totalHours >= 1){
                format ='%H hr %M min %S sec';
              }
              //console.log(totalHours)
              $(this).html(event.strftime(format));

          }).on('finish.countdown', function(event) {

            if (after_atc_1){
                selectedDate = new Date().valueOf() + val;
                localStorage.setItem(nt_cartcd_mn, selectedDate);
                cart_cd.countdown(selectedDate.toString());
            } else {
                // remove all item cart
                $(this).parent().remove();
                $.ajax(params);
                localStorage.removeItem(nt_cartcd_mn);
            }
            //$(this).parent().addClass('disabled').html('This offer has expired!');
        });
    }
    cartCountdown();
    ///////////////////////////////////////////////////////
    
    ////////////////// Show Whatapp widget icon based on back to top button ///////////////
    /*function BackToTop() {
          if($('.wa__widget_container').length > 0) {
            var $backToTop = $('#t4s-backToTop'),
            scrollTop = parseInt($backToTop.data('scrolltop')),
            $window = $(window),
            debounce_timer;
            if ( ( $window.width() < 768 && $backToTop.data('hidden-mobile') ) || $backToTop.length == 0 ) return;
    
              window.addEventListener("scroll", () => {
                  if (debounce_timer) { clearTimeout(debounce_timer); }
    
                debounce_timer = setTimeout(function() {
                  if (window.scrollY > scrollTop) {
                      $('.wa__widget_container').addClass('is--show');
                  } else {
                        $('.wa__widget_container').removeClass('is--show');
                  }
                }, 40);
              });
        }    
    } 
    BackToTop();*/
    ///////////////////////////////////////////////////////

    function updateATCButtonClass() {
      const atcButton = document.querySelector('[data-atc-form]');
      const soldoutBtn = document.querySelector('.t4s-product-form__submit');
      if (!atcButton) {
        soldoutBtn.classList.add('t4s-custom-sold-out');
      } else {
        soldoutBtn.classList.remove('t4s-custom-sold-out');
      }

      const isDisabled =
        atcButton.hasAttribute('disabled') ||
        atcButton.getAttribute('aria-disabled') === 'true';

      if (isDisabled) {
        soldoutBtn.classList.add('t4s-custom-sold-out');
      } else {
        soldoutBtn.classList.remove('t4s-custom-sold-out');
      }
    }

    const productForm = document.querySelector('form[action*="/cart/add"]');

    if (productForm) {
      const observer = new MutationObserver(() => {
        updateATCButtonClass();
      });

      observer.observe(productForm, {
        childList: true,
        subtree: true,
      });
    }

    // Run once on page load
    updateATCButtonClass();


  });

  // function updatePreorderBadges() {
  //   if (!window.variantDataMap) {
  //     console.warn("⚠️ variantDataMap not found.");
  //     return;
  //   }

  //   setTimeout(function () {
  //     $(".t4s-product").each(function () {
  //       var $product = $(this);
  //       var productOptions = $product.data("product-options");

  //       if (!productOptions || !productOptions.VariantFirstID) {
  //         console.warn("No variant ID found for product:", $product);
  //         return;
  //       }

  //       var variantId = productOptions.VariantFirstID;
  //       var variantData = window.variantDataMap[variantId];

  //       if (!variantData) {
  //         console.warn("No variant data found for variant ID:", variantId);
  //         return;
  //       }
  //       // Extract values safely
  //       var preorderSwitch = variantData.pre_order_to_add_to_cart_switch === true;
  //       var inventoryManagement = variantData.inventory_management;
  //       var inventoryQuantity = Number(variantData.inventory_quantity) || 0;
  //       var available = variantData.available === true;

  //       // Determine preorder state
  //       var isPreOrder =
  //         inventoryManagement === "shopify" &&
  //         inventoryQuantity <= 0 &&
  //         available;

  //       var preorderBadge = $product.find("[data-badge-preorder]");

  //       if (isPreOrder && preorderSwitch) {
  //         preorderBadge.css("display", "none");
  //       } else {
  //         preorderBadge.css("display", "inline-block");
  //       }
  //     });
  //   }, 1000);
  // }

  // updatePreorderBadges();


  function updatePreorderBadges() {
    if (!window.variantDataMap) {
      console.warn("⚠️ variantDataMap not found.");
      return;
    }

    // Function to update a single product badge
    function processProduct($product) {
      var productOptions = $product.data("product-options");

      if (!productOptions || !productOptions.VariantFirstID) {
        console.warn("No variant ID found for product:", $product);
        return;
      }

      var variantId = productOptions.VariantFirstID;
      var variantData = window.variantDataMap[variantId];

      if (!variantData) {
        console.warn("No variant data found for variant ID:", variantId);
        return;
      }

      // Extract values safely
      var preorderSwitch = variantData.pre_order_to_add_to_cart_switch === true;
      var inventoryManagement = variantData.inventory_management;
      var inventoryQuantity = Number(variantData.inventory_quantity) || 0;
      var available = variantData.available === true;

      // Determine preorder state
      var isPreOrder =
        inventoryManagement === "shopify" &&
        inventoryQuantity <= 0 &&
        available;

      var preorderBadge = $product.find("[data-badge-preorder]");
      preorderBadge.css("display", isPreOrder && preorderSwitch ? "none" : "inline-flex");
    }

    // Initial run (for current DOM)
    setTimeout(function () {
      $(".t4s-product").each(function () {
        processProduct($(this));
      });
    }, 2000);

    // MutationObserver for future DOM additions
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        $(mutation.addedNodes)
          .find(".t4s-product")
          .addBack(".t4s-product")
          .each(function () {
            processProduct($(this));
          });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // Run it once
  updatePreorderBadges();


  ////////////////// product-form.liquid for PERSONALIZATION product ////////////////////
  //$(document).on('click', '.cl-po--option[data-option="personalize"], .cl-po--swatch-item.grow:not(".personalize"), .cl-po--swatch-button', function(){
  $(document).on('click', '.cl-po--option[data-option="personalize"] .cl-po--swatch-item.grow:not(".personalize") .cl-po--swatch-button', function(){
      $('body').addClass('no-scrolling');
      
      if($('.t4s-product-form__buttons .single_add_to_cart_buttn').length != 0){
        console.log('returned');
        return;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      const productId = $('input[name="product-id"]').val();
    
      var htmlElement = `<form method="post" action="/cart/add"><div class="t4s-product-form__buttons cl-cart-validate" style="--pr-btn-round:0px;" data-live-validate="">
                            <div class="t4s-d-flex t4s-flex-wrap">
                              <input type="hidden" name="quantity" value="1">
                              <button data-animation-atc='{ "ani":"none","time":6000 }' type="submit" name="add" data-atc-form class="single_add_to_cart_buttn t4s-product-form__submit t4s-btn t4s-btn-base t4s-btn-style-default t4s-btn-color-primary t4s-w-100 t4s-justify-content-center  t4s-btn-effect-default t4s-btn-loading__svg" style="display:none;"><span class="t4s-btn-atc_text" style="display: inline;">Add to cart</span>
                                <span class="t4s-loading__spinner" hidden>
                                    <svg width="16" height="16" hidden class="t4s-svg-spinner" focusable="false" role="presentation" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="t4s-path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>
                                </span>
                              </button>
                            </div>
                        </div>
                        <input type="hidden" name="id" value="${variantId}">
                        <input type="hidden" name="product-id" value="${productId}">
                        </form>`;
    setTimeout(() => {
      if($('.t4s-product-form__buttons .single_add_to_cart_buttn').length == 0){
          console.log('not returned');
          $(htmlElement).insertAfter('.options-atc .atc-wrap .cl-po--swatch-button');
          $('.t4s-product-form__buttons .single_add_to_cart_buttn').css('display', 'block');
          $('.options-atc .atc-price').css('display', 'none');
          $('.options-atc .atc-button button.cl-po--swatch-button').css('display', 'none');
       }
      }, 300);

    $(document).ready(function() {
      $('.cl-po--option[data-option="tab_group"] .cl-po--group .cl-po--option .cl-po--tab').first().click();
    });
  });

 $(document).on('click', '.ldcv', function(){
        console.log('clicked');
        setTimeout(() => {
          if(!$(this).hasClass('active')){
            $('body').removeClass('no-scrolling');
          }
        }, 300);
  });

  $(document).on('click', '.cl-po--option[data-option="engrave_tab"]', function(){
    if(!$('.cl-po--option[data-option="engrave_tab"] .cl-po--tab').hasClass('checked')){
      $('.cl-po--option[data-option="engrave_tab"] .cl-po--tab').addClass('checked');
      $('.cl-po--option[data-option="artwork_tab"] .cl-po--tab').removeClass('checked');
  
      $('.cl-po--option[data-option="toggle_engrave"] .cl-po--checkbox-item').click();
      setTimeout(() => {
        $('.cl-po--option[data-option="toggle_artwork"] .cl-po--checkbox-item').click();
      }, 100);
    }
  });
  
  $(document).on('click', '.cl-po--option[data-option="artwork_tab"]', function(){
    if(!$('.cl-po--option[data-option="artwork_tab"] .cl-po--tab').hasClass('checked')){
      $('.cl-po--option[data-option="artwork_tab"] .cl-po--tab').addClass('checked');
      $('.cl-po--option[data-option="engrave_tab"] .cl-po--tab').removeClass('checked');
  
      $('.cl-po--option[data-option="toggle_artwork"] .cl-po--checkbox-item').click();
      setTimeout(() => {
        $('.cl-po--option[data-option="toggle_engrave"] .cl-po--checkbox-item').click();
      }, 100);
    }
  });

  $(document).on('click', '[data-option="tab_group"] .cl-po--option', function () {

    const option = $(this).data('option'); // e.g. initials_ui
    const key = option.replace('_ui', ''); // initials
    const $tab = $(this).find('.cl-po--tab');

    if ($tab.hasClass('checked')) return;

    // 1. Reset all tabs
    $('[data-option="tab_group"] .cl-po--tab').removeClass('checked');

    // 2. Activate clicked tab
    $tab.addClass('checked');

    // 3. Uncheck ALL radios first
    $('.cl-po--option[data-option^="toggle_"] .cl-po--radio-item').each(function () {
      $(this).prop('checked', false).trigger('change');
    });

    // 4. Check ONLY the matching one
    const $targetRadio = $(`.cl-po--option[data-option="toggle_${key}"] .cl-po--radio-item`);

    if ($targetRadio.length && !$targetRadio.is(':checked')) {
      setTimeout(() => {
        $targetRadio.prop('checked', true).trigger('change');
      }, 100);
    }

  });

  window.addEventListener('options:rendered', function(e) {
    // print the option to the console
    console.log('options rendered');
      
      if($('.t4s-product-form__buttons .single_add_to_cart_buttn').length != 0){
        console.log('returned');
        return;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      const productId = $('input[name="product-id"]').val();
      
      var htmlElement = `<form method="post" action="/cart/add">
                            <div class="t4s-product-form__buttons cl-cart-validate" style="--pr-btn-round:0px;" data-live-validate="">
                            <div class="t4s-d-flex t4s-flex-wrap">
                              <input type="hidden" name="quantity" value="1">
                              <button data-animation-atc='{ "ani":"none","time":6000 }' type="submit" name="add" data-atc-form class="single_add_to_cart_buttn t4s-product-form__submit t4s-btn t4s-btn-base t4s-btn-style-default t4s-btn-color-primary t4s-w-100 t4s-justify-content-center  t4s-btn-effect-default t4s-btn-loading__svg" style="display:none;"><span class="t4s-btn-atc_text" style="display: inline;">Add to cart</span>
                                <span class="t4s-loading__spinner" hidden>
                                    <svg width="16" height="16" hidden class="t4s-svg-spinner" focusable="false" role="presentation" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="t4s-path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>
                                </span>
                              </button>
                            </div>
                        </div>
                        <input type="hidden" name="id" value="${variantId}">
                        <input type="hidden" name="product-id" value="${productId}">
                        </form>`;
     if($('.t4s-product-form__buttons .single_add_to_cart_buttn').length == 0){
    //setTimeout(() => {
        console.log('not returned');
        $(htmlElement).insertAfter('.options-atc .atc-wrap .cl-po--swatch-button');
        $('.t4s-product-form__buttons .single_add_to_cart_buttn').css('display', 'block');
        $('.options-atc .atc-price').css('display', 'none');
        $('.options-atc .atc-button button.cl-po--swatch-button').css('display', 'none');
      //}, 500);
    }  
  }); 
  ////////////////////////////////////////////////////////// 

//////////////////////////////////////////////////////////////

// Printing price

window.addEventListener('option:changed', function(e) {

  // e.detail contains the option reference
  var option = e.detail;

  // print the option to the console
  console.debug('option changed =================', option);

  // check if the option is the one we want
  if(option.name == 'art_work_type'){
      // check if the value is the one we want
      if(option.value == 'Printing'){
        // do something
        console.log("--------------===========")
      }
   }

});
// $(document).ready(function(){
//   var parentDiv = $('main .flickityt4s-slider'); 
//   var t4sCurrentCatIndex = parentDiv.children().filter('.t4s-current-cat').index();
//   setTimeout(function() {
//     var $carousel = $(".t4s-top-list-collections");
//     $carousel.flickityt4s('selectCell', t4sCurrentCatIndex);
//   },1000);
// });
window.onload = function () {
  var parentDiv = $('main .flickityt4s-slider');
  var t4sCurrentCatIndex = parentDiv.children().filter('.t4s-current-cat').index();
  setTimeout(function() {
    var $carousel = $(".t4s-top-list-collections");
    if ($carousel.length && $.fn.flickityt4s) {
      $carousel.flickityt4s('selectCell', t4sCurrentCatIndex);
    } else {
      console.error("FlickityT4S is not initialized or missing.");
    }
  }, 1000);
};


function waitForQikify() {
  if (window.QikifyBoosterKit) {
    window.QikifyBoosterKit.renderCartContents = function () {
      if (window.T4SThemeSP?.Cart?.init) {
          window.T4SThemeSP.Cart.init();
          document.dispatchEvent(new CustomEvent('cart:refresh:opend'));
      }
    };
  } else {
    setTimeout(waitForQikify, 100);
  }
}

waitForQikify();



